import {EventKind} from '../const';

import {createCancelSpendEvent as whenCancelSpend} from './plainEvent';
import {
  createRedistributeSavedEvent as whenRedistributeSaved,
  createTransferSavedToNextDayEvent as whenTransferSaved,
} from './transferEvent';

import {createEvent as whenAddSpend} from './addSpend';
import {
  createAddIncomeEvent as whenAddIncome,
  createAddRefillEvent as whenAddRefill,
} from './appendMoney';

import {createEvent as whenOpenHistory} from './openHistory';
import {createEvent as whenDeleteSpend} from './deleteSpend';
import {createEvent as whenStartBudget} from './startBudget';

import {createEvent as whenUserSpentMoney} from './userSpentMoney';
import {createEvent as whenUserSavedMoney} from './userSavedMoney';

export const Registry: Record<AnalyticsEventName, EventFactory<AnalyticsPayload>> = {
  [EventKind.OpenHistory]: whenOpenHistory,
  [EventKind.CreateBudget]: whenStartBudget,
  [EventKind.RedistributeSaved]: whenRedistributeSaved,
  [EventKind.TransferSavedToNextDay]: whenTransferSaved,

  [EventKind.AddSpend]: whenAddSpend,
  [EventKind.AddIncome]: whenAddIncome,
  [EventKind.AddRefill]: whenAddRefill,
  [EventKind.CancelSpend]: whenCancelSpend,
  [EventKind.DeleteSpend]: whenDeleteSpend,

  [EventKind.UserSavedMoney]: whenUserSavedMoney,
  [EventKind.UserSpentEverything]: whenUserSpentMoney,
};
